module.exports = __webpack_public_path__ + "static/media/evergreen-dashboard.c8a704bc.png";